import { useMemo } from 'react';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { getRandomInt } from '~/shared';
import caseImage from '../../assets/images/case.png';
import { useLayoutSelector } from '../../redux';
import {
	StyledBlurBg,
	StyledCaseImage,
	StyledContainer,
	StyledSvg,
	StyledTextContainer,
} from './CaseBanner.styled';

const CaseBanner = () => {
	const offer = useObservable(rage.vehicleShop.getVehicleShopOffer());

	const expanded = useLayoutSelector(
		(state) => state.menuPanels.expanded.colorPicker,
	);
	const [dur1, dur2] = useMemo(
		() => [getRandomInt(20, 40), getRandomInt(15, 30)],
		[],
	);

	if (!offer) {
		return null;
	}

	return (
		<StyledContainer $expanded={!expanded}>
			<StyledBlurBg style={{ backgroundColor: offer.color }} />
			<StyledSvg width="160" height="160" viewBox="0 0 160 160" fill="none">
				<circle
					cx="80"
					cy="80"
					r="39.5"
					stroke={offer.color}
					strokeOpacity="0.1"
				/>
				<circle
					cx="80"
					cy="80"
					r="59.5"
					stroke={offer.color}
					strokeOpacity="0.05"
				/>
				<circle
					cx="80"
					cy="80"
					r="79.5"
					stroke={offer.color}
					strokeOpacity="0.02"
				/>
				<g>
					<circle cx="21" cy="80" r="3" fill={offer.color} />
					<animateTransform
						attributeName="transform"
						attributeType="XML"
						type="rotate"
						from={`0 80 80`}
						to={`360 80 80`}
						dur={`${dur1}s`}
						begin={`${0}s`}
						repeatCount="indefinite"
					/>
				</g>
				<g>
					<circle cx="105" cy="49" r="3" fill={offer.color} />
					<animateTransform
						attributeName="transform"
						attributeType="XML"
						type="rotate"
						from={`0 80 80`}
						to={`-360 80 80`}
						dur={`${dur2}s`}
						begin={`${0}s`}
						repeatCount="indefinite"
					/>
				</g>
			</StyledSvg>
			{/* @TODO: Добавить изображение кейса */}
			<StyledCaseImage src={caseImage} />
			<StyledTextContainer>
				<Text style={{ fontSize: 16, fontWeight: 500 }}>{offer.title}</Text>
				<Text style={{ fontSize: 14, opacity: 0.5 }}>{offer.description}</Text>
			</StyledTextContainer>
		</StyledContainer>
	);
};

export { CaseBanner };
